export const exchangeOptions = [
    { value: 'Binance', label: 'Binance' },
    { value: 'Bybit', label: 'Bybit' },
  ];

  export const mainstrategy = [
    { value: "TP_SL", label: "TP SL" },
    { value: "Liquidation", label: "Liquidation" },
  ];
  
  export const tpSlOptions = [
    { value: "TP_SL Hedge", label: "TP SL Hedge" },
    { value: "TP_SL Long", label: "TP SL Long" },
    { value: "TP_SL Short", label: "TP SL Short" },
  ];
  
  export const liquidationOptions = [
    { value: "Long", label: "Long" },
    { value: "Short", label: "Short" },
  ];
  

  export const symbolOptions = [
    { label: "BTC/USDT", value: "BTC/USDT" },
    { label: "ETH/USDT", value: "ETH/USDT" },
    { label: "BNB/USDT", value: "BNB/USDT" },
    { label: "ADA/USDT", value: "ADA/USDT" },
    { label: "XRP/USDT", value: "XRP/USDT" },
    { label: "SOL/USDT", value: "SOL/USDT" },
    { label: "DOT/USDT", value: "DOT/USDT" },
    { label: "DOGE/USDT", value: "DOGE/USDT" },
    { label: "AVAX/USDT", value: "AVAX/USDT" },
    { label: "MATIC/USDT", value: "MATIC/USDT" },
  ];
  
export const slpriceoptions = [
    { value: 'triggered_price', label: 'Triggered Price' },
    { value: 'entry_price', label: 'Entry Price' },
  ];

  export const timeframeOptions = [
  
    { value: '1h', label: '1 Hour' },
    { value: '6h', label: '6 Hours' },
    { value: '12h', label: '12 Hours' },
    { value: '1d', label: '1 Day' },
    
  ];  


  export const guidebasedonstrategy = [
    {
      value: "TP_SL",
      label: "TP/SL",
      content: `
        <div class="space-y-6">
          <h3 class="text-lg font-semibold text-foreground">TP/SL Strategy Overview</h3>
          <p class="text-sm text-muted-foreground">
            <strong>TP/SL (Take Profit/Stop Loss)</strong> is an automated trading approach that opens and closes positions based on preset profit and loss levels — ensuring emotion-free, risk-managed trading.
          </p>
  
          <hr class="border-border" />
  
          <h4 class="font-semibold text-foreground text-base">Strategy Types</h4>
          <div class="space-y-3 text-sm text-muted-foreground">
            <div>
              <strong class="text-primary">TP/SL Hedge</strong>
              <p>Opens both <span class="text-green-500 font-medium">LONG</span> & <span class="text-red-500 font-medium">SHORT</span> at the same entry price.<br/>
              Each side has its own TP/SL. When one side closes, the other’s SL adjusts.<br/>
              Cycles continue until both sides close.<br/>
              <strong>Best for:</strong> Volatile or uncertain markets.</p>
            </div>
  
            <div>
              <strong class="text-primary">TP/SL Long</strong>
              <p>Opens only <span class="text-green-500 font-medium">LONG</span> positions.<br/>
              Exits at TP (profit) or SL (loss), then restarts.<br/>
              <strong>Best for:</strong> Bullish/uptrend markets.</p>
            </div>
  
            <div>
              <strong class="text-primary">TP/SL Short</strong>
              <p>Opens only <span class="text-red-500 font-medium">SHORT</span> positions.<br/>
              Exits at TP or SL, then restarts.<br/>
              <strong>Best for:</strong> Bearish/downtrend markets.</p>
            </div>
          </div>
  
          <hr class="border-border" />
  
          <h4 class="font-semibold text-foreground text-base">Key Settings</h4>
          <ul class="list-disc list-inside text-sm text-muted-foreground space-y-1">
            <li><strong>Leverage:</strong> 1–10× (higher = higher risk/reward)</li>
            <li><strong>Fee Rate:</strong> 0.05% per trade (entry/exit)</li>
            <li><strong>Timeframes:</strong> 1h / 6h / 12h / 1d</li>
          </ul>
  
          <hr class="border-border" />
  
          <h4 class="font-semibold text-foreground text-base flex items-center">
            <i class="lucide lucide-shield-alert mr-2 text-yellow-500"></i> Risk Tips
          </h4>
          <ul class="list-disc list-inside text-sm text-muted-foreground space-y-1">
            <li>Start with low leverage (1–3×).</li>
            <li>Use Hedge in volatile markets.</li>
            <li>Use Long in bullish trends, Short in bearish trends.</li>
            <li>Always backtest before live trading.</li>
          </ul>
        </div>
      `
    },
    {
      value: "Liquidation",
      label: "Liquidation",
      content: `
        <div class="space-y-6">
          <h3 class="text-lg font-semibold text-foreground">Liquidation Strategy Overview</h3>
          <p class="text-sm text-muted-foreground">
            A high-risk, high-reward leveraged strategy that scales position size after losses (martingale-style) and aims to recover via take-profit targets while managing liquidation risk.
          </p>
  
          <hr class="border-border" />
  
          <h4 class="font-semibold text-foreground text-base">Strategy Types</h4>
          <div class="space-y-3 text-sm text-muted-foreground">
            <div>
              <strong class="text-primary">Liquidation Long</strong>
              <p>Opens leveraged <span class="text-green-500 font-medium">LONG</span> positions betting on price increase.<br/>
              Auto-calculates liquidation, TP, SL & next position size.<br/>
              <strong>Best for:</strong> Bullish markets.</p>
            </div>
  
            <div>
              <strong class="text-primary">Liquidation Short</strong>
              <p>Opens leveraged <span class="text-red-500 font-medium">SHORT</span> positions betting on price drop.<br/>
              Auto-calculates liquidation, TP, SL & next position size.<br/>
              <strong>Best for:</strong> Bearish markets.</p>
            </div>
          </div>
  
          <hr class="border-border" />
  
          <h4 class="font-semibold text-foreground text-base">Key Parameters</h4>
          <ul class="list-disc list-inside text-sm text-muted-foreground space-y-1">
            <li><strong>initial_investment:</strong> Starting capital</li>
            <li><strong>subsequent_multiplier:</strong> Increase size after loss (1.5x–10x)</li>
            <li><strong>leverage:</strong> 1x–10x</li>
            <li><strong>take_profit_percentage:</strong> Profit target %</li>
            <li><strong>stop_loss_percent:</strong> Max loss % before closing</li>
          </ul>
  
          <hr class="border-border" />
  
          <h4 class="font-semibold text-foreground text-base">Core Logic</h4>
          <ul class="list-disc list-inside text-sm text-muted-foreground space-y-1">
            <li>Uses daily candles (1d)</li>
            <li>Liquidation Price auto-calculated from leverage</li>
            <li>After Loss: Increase position by multiplier</li>
            <li>After Profit: Reset to initial investment</li>
          </ul>
  
          <hr class="border-border" />
  
          <h4 class="font-semibold text-foreground text-base flex items-center">
            <i class="lucide lucide-alert-triangle mr-2 text-red-500"></i> Risk Profile
          </h4>
          <div class="text-sm text-muted-foreground">
            <p>⚠️ <strong>High Risk Strategy</strong></p>
            <ul class="list-disc list-inside space-y-1">
              <li>Entire position can liquidate</li>
              <li>Position size grows exponentially after losses</li>
              <li>Needs high capital for recovery cycles</li>
            </ul>
          </div>
  
          <hr class="border-border" />
  
          <h4 class="font-semibold text-foreground text-base flex items-center">
            <i class="lucide lucide-lightbulb mr-2 text-yellow-500"></i> Best Practices
          </h4>
          <ul class="list-disc list-inside text-sm text-muted-foreground space-y-1">
            <li>Start small, use low multiplier (1.5x–2x)</li>
            <li>Use 2–5x leverage max</li>
            <li>Ensure sufficient capital for drawdowns</li>
            <li>Apply in trending markets (bullish/bearish)</li>
            <li>Always backtest before live trading</li>
          </ul>
        </div>
      `
    }
  ];


  export const LIVEIP = [
    "192.212.0.50",
    "192.212.0.51",
    "192.212.0.52",
    "192.212.0.53",
    "192.212.0.54",
  ];
  
  